import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import CommentsContainer from "../comment/comments.container";
import {
  Typography,
  Box,
  makeStyles,
  Paper,
  Grid,
  Switch,
  Card,
  CardContent,
  CardActions,
  Button,
  Dialog,
} from "@material-ui/core";
import RatingComponent from "../rating/rating.component";
import { getPreviewImageUrl } from "../../utils/cloudinary/cloudinary-service";
import { createStructuredSelector } from "reselect";
import { isReportRateable } from "../../redux/reports/report.selector";

// Anzeige eines Reports im Detail
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  content: {
    display: "flex",
    flexDirection: "row",

    justifyContent: "space-between",
  },
  fragen: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "800px",
    },
  },
  panelRight: {
    [theme.breakpoints.up("sm")]: {
      width: "230px",
    },
  },
  image: {
    height: 220,
    width: 220,
    margin: 5,
    borderRadius: 15,
    cursor: "pointer",
  },
  popupHeader: {
    position: "absolute",
    top: "0",
    right: "0",
    backgroundColor: "rgba(200, 200, 200, 0.6)",
    borderRadius: 4,
  },
  popupImage: {
    height: "0%",
    width: "100%",
  },
}));

const ReportComponent = ({ currentReport, currentUser, isReportRateable }) => {
  const [bild1Url, setBild1Url] = useState();
  const [bild2Url, setBild2Url] = useState();
  const [popupUrl, setPopupUrl] = useState("");

  useEffect(() => {
    currentReport.bild1 &&
      getPreviewImageUrl(currentReport.bild1, setBild1Url, 800);
    currentReport.bild2 &&
      getPreviewImageUrl(currentReport.bild2, setBild2Url, 800);
  }, [currentReport.bild1, currentReport.bild2]);
  const classes = useStyles();
  const handleClose = () => setPopupUrl("");
  return (
    <Grid className={classes.root}>
      <Box mb={3}>
        <Typography variant="h3">{currentReport.titel}</Typography>
      </Box>
      <div className={classes.content}>
        <Dialog open={popupUrl} onClose={handleClose}>
          <Button
            className={classes.popupHeader}
            onClick={handleClose}
            size="small"
          >
            X
          </Button>
          <img className={classes.popupImage} src={popupUrl} alt="" />
        </Dialog>
        <div className={classes.fragen}>
          <Box mb={2} mt={2}>
            <Typography variant="h5">Was haben wir gemacht?</Typography>
          </Box>
          <Typography variant="body1">{currentReport.frage1}</Typography>

          <Box mb={2} mt={2}>
            <Typography variant="h5">Was ist daran für uns neu?</Typography>
          </Box>
          <Typography variant="body1">{currentReport.frage2}</Typography>

          <Box mb={2} mt={2}>
            <Typography variant="h5">
              Gab es einen ähnlichen Versuch schon mal bei uns?
            </Typography>
          </Box>
          <Typography variant="body1">{currentReport.frage3}</Typography>

          <Box mb={2} mt={2}>
            <Typography variant="h5">Wie ist es gelaufen?</Typography>
          </Box>
          <Typography variant="body1">{currentReport.frage4}</Typography>

          <Box mb={2} mt={3}>
            <Typography variant="h5">
              Haben sich unsere Erwartungen erfüllt?
            </Typography>
          </Box>
          <Typography variant="body1">{currentReport.frage5}</Typography>

          <Box mb={2} mt={2}>
            <Typography variant="h5">Was haben wir gelernt?</Typography>
          </Box>
          <Typography variant="body1">{currentReport.frage6}</Typography>

          {currentReport.kontakt ? (
            <div className="contact">
              <Box mb={2} mt={2}>
                <Typography variant="h5">Kontakt:</Typography>
              </Box>
              <Typography variant="body1">{currentReport.kontakt}</Typography>
            </div>
          ) : null}
          <Box mb={2} mt={2}>
            <Typography variant="h5">Autor:</Typography>
          </Box>
          <Typography variant="body1">{currentReport.autor}</Typography>
          {currentReport.oeffentlich ? (
            <Box mb={2} mt={2}>
              <Typography variant="body1">
                <Switch checked disabled /> Dieser Bericht darf im Dekanat
                veröffentlicht werden
              </Typography>
            </Box>
          ) : null}
          {currentUser ? (
            <Box mb={2} mt={2}>
              <Typography variant="h5">Kommentare:</Typography>
              <Box mb={2} mt={2}>
                <CommentsContainer />
              </Box>
            </Box>
          ) : null}
        </div>
        {isReportRateable || currentReport.bild1 || currentReport.bild2 ? (
          <div className={classes.panelRight}>
            {isReportRateable ? (
              <Paper elevation={3}>
                <Box m={2}>
                  <Box mb={2}>
                    <Typography variant="h5">Ihre Bewertung</Typography>
                  </Box>
                  <RatingComponent
                    key={currentUser.id + "+" + currentReport.id}
                  />
                </Box>
              </Paper>
            ) : null}
            {currentReport.bild1 ? (
              <Paper elevation={3}>
                <img
                  className={classes.image}
                  src={bild1Url}
                  alt=""
                  onClick={() => setPopupUrl(bild1Url)}
                />
              </Paper>
            ) : null}
            {currentReport.bild2 ? (
              <Paper elevation={3} style={{ marginTop: 15 }}>
                <img
                  className={classes.image}
                  src={bild2Url}
                  alt=""
                  onClick={() => setPopupUrl(bild2Url)}
                />
              </Paper>
            ) : null}
            {currentReport.pdf && currentReport.pdf.url ? (
              <Card style={{ marginTop: 15 }}>
                <CardContent>
                  <Typography variant="h5">Download</Typography>
                </CardContent>

                <CardActions>
                  {" "}
                  <Button
                    href={currentReport.pdf.url}
                    alt="Download"
                    color="primary"
                  >
                    {currentReport.pdf.name}
                  </Button>
                </CardActions>
              </Card>
            ) : null}
          </div>
        ) : null}
      </div>
    </Grid>
  );
};
const mapStateToProps = createStructuredSelector({
  isReportRateable: isReportRateable,
});
export default connect(mapStateToProps)(ReportComponent);
